import { api } from "../base";
import type {
  ITcaReportCreateResponse,
  ITcaReportJob,
  ITcaReportRequest,
} from "@pulse-ui/codegen-v2/generated_ts/tca_report";

export type { ITcaReportCreateResponse, ITcaReportJob, ITcaReportRequest };
export type { ITcaTranche } from "@pulse-ui/codegen-v2/generated_ts/tca_report";

const tcaReportsEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Submits a TCA report request. Returns 202 + a job id once the inputs
     * validate; generation (public exchange candle fetch -> metrics -> PDF)
     * runs server-side. Poll `getTcaReportJob` until status is done/failed.
     */
    createTcaReport: build.mutation<ITcaReportCreateResponse, ITcaReportRequest>({
      query: (body) => ({
        url: "/api/trading-ops/v1/tca-reports",
        method: "POST",
        body,
      }),
    }),

    /**
     * Polls a TCA report job. When `status === "done"` the payload carries
     * the full computed `report` data (rendered into the PDF client-side by
     * the tca-report widget) plus the suggested `filename`.
     */
    getTcaReportJob: build.query<ITcaReportJob, string>({
      query: (jobId) => ({
        url: `/api/trading-ops/v1/tca-reports/${jobId}`,
      }),
    }),
  }),
});

export const {
  useCreateTcaReportMutation,
  useGetTcaReportJobQuery,
  useLazyGetTcaReportJobQuery,
} = tcaReportsEndpoints;
